import React, { Component } from 'react';
import {numberParce} from '../../../../server/util'
class TotalInvoiceRevenue extends Component {
    render() {
        const {data}=this.props
        return (
            <div className="mini-stat bg-6 clearfix rounded text-center">
            <span className="mini-stat-icon" style={{float:'none'}}><i className="fa fa-usd fg-6"></i></span>
            <div className="mini-stat-info">
                Total Invoice Revenue
                {data.loading?<span className='loading'></span>:<span>$ {numberParce(((data.data||{}).TotalInvoiceRevenue||{}).totalAmount).toFixed(2)}</span>}                
            </div>
        </div>
        );
    }
}
export default TotalInvoiceRevenue;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Home/DashboardItems/totalInvoiceRevenue.jsx